export const api = {
  inspectionPlan: {
    // 资产巡检列表
    queryAssetsTypeList: 'bms/assets/queryAssetsTypeList',//查询资产类型列表
    addInspectionPlan: 'bms/assetinspection/addAssetInspectionPlan.json',//资产巡检计划新增接口
    updateInspectionPlan: 'bms/assetinspection/updateAssetInspectionPlan.json',//资产巡检计划修改接口
    deleteInspectionPlan: 'bms/assetinspection/deleteAssetInspectionPlan.json',//资产巡检计划删除接口
    queryInspectionPlan: 'bms/assetinspection/queryAssetInspectionPlanByPage.json',//资产巡检计划列表查询接口
    queryInspectionPlanDetail: 'bms/assetinspection/queryAssetInspectionPlanDetail.json',//资产巡检计划详情查询
    startOrStopPlan: 'bms/assetinspection/startOrStopAssetInspectionPlan.json', //资产巡检计划启用/禁用接口
    queryWorkGroupByAreaOrDevice: 'cms/workGroup/queryWorkGroupByAreaOrDevice.json', //资产巡检人员查询接口
    queryAreaByAccountName: 'cms/area/queryAreaByAccountName.json', //资产巡检范围查询接口
    queryTaskCount: 'bms/assetinspection/queryAssetInspectionTaskCount.json', //资产巡检计划任务总数接口
    querySubTaskCount: 'bms/assetinspection/queryAssetInspectionSubTaskCount.json', //资产巡检计划任务下完成/未完成总数接口
    queryUndoTask: 'bms/assetinspection/queryAssetInspectionUndoTaskByPage.json', //资产巡检未完成任务列表查询
    queryCompleteTask: 'bms/assetinspection/queryAssetInspectionCompleteTaskByPage.json', //资产巡检已完成任务列表查询接口
    querySubTaskByPage: 'bms/assetinspection/queryAssetInspectionSubTaskByPage.json', //资产巡检计划任务下资产列表查询接口
    querySubTaskDetail: 'bms/assetinspection/queryAssetInspectionSubTaskDetail.json', //资产巡检计划任务下资产详情询接口
    SubmitSubTask: 'bms/assetinspection/SubmitAssetInspectionSubTask.json', //巡检任务下资产入库接口
    queryTaskRecordList: 'bms/assetinspection/queryAssetInspectionTaskRecordList.json', //巡检任务记录查询接口
    queryTaskRecordDetail: 'bms/assetinspection/queryAssetInspectionTaskRecordDetail.json', //巡检任务记录详情查询接口
    querySysConfigList: 'cms/sysConfig/querySysConfigList.json', //巡检项查询
    queryPatrolItemConfig: 'bms/patrolitem/queryPatrolItemConfig.json', //巡检项配置查询接口
    addPatrolItemConfig: 'bms/patrolitem/addPatrolItemConfig.json', //巡检项配置新增
    deletePatrolItemConfig: 'bms/patrolitem/deletePatrolItemConfig.json', //巡检项配置删除接口
  }
}